import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router/auto";
import { createPinia } from "pinia";
import { createI18n } from "vue-i18n";

import App from "./App.vue";

import "./index.css";
import "./font.css";

import messages from "@intlify/unplugin-vue-i18n/messages";

import * as authService from "@/services/auth";

const i18n = createI18n({
  legacy: false,
  locale: "de",
  messages,
});

const pinia = createPinia();

const router = createRouter({
  history: createWebHistory(),
  extendRoutes: (routes) => [
    {
      path: "/",
      redirect: () => ({ path: "/dashboard" }),
    },
    ...routes,
  ],
});

router.beforeEach(async (to) => {
  const isLoggedIn = await authService.isLoggedIn();
  if (!to.meta.isPublic && !isLoggedIn) {
    return {
      path: "/auth/login",
      query: { redirect: encodeURIComponent(to.fullPath) },
    };
  }

  const isTiktokLoginCallback = to.path === "/auth/tiktok/callback";
  const isYoutubeLoginCallback = to.path === "/auth/youtube/callback";
  const isSocialMediaLoginCallback =
    to.path === "/auth/instagram/callback" || to.path === "/auth/facebook/callback";
  const platformConnect = to.path.split("/")[2] ?? "";
  if (isSocialMediaLoginCallback) {
    const searchParams = new URLSearchParams(to.hash.substring(1));
    const accessToken = searchParams.get("access_token") as string;
    const stateParam = searchParams.get("state")?.replace("=", ":") ?? "";
    const pageId = stateParam?.split(":")[1]?.match(/\d+/)?.join("") ?? "";

    return {
      path: "/admin",
      query: { platformConnect, accessToken, pageId },
    };
  } else if (isTiktokLoginCallback || isYoutubeLoginCallback) {
    const accountId = to.query.account;
    return {
      path: "/admin",
      query: { platformConnect, accountId },
    };
  }
});

const app = createApp(App);

app.use(i18n);
app.use(router);
app.use(pinia);

app.mount("#app");
